import request from '@/utils/request'

// 登录方法
export function login(username, password, code, uuid) {
  const data = {
    username,
    password,
    code,
    uuid
  }
  data.userCategory = 'common_user'
  return request({
    url: '/login',
    headers: {
      isToken: false,
      repeatSubmit: false
    },
    method: 'post',
    data: data
  })
}

// 注册方法
export function register(data) {
  return request({
    url: '/register',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/getInfo',
    method: 'get'
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  })
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: '/captchaImage',
    headers: {
      isToken: false
    },
    method: 'get',
    timeout: 20000
  })
}

// 用户注册
export function registFrontUser(data) {
  return request({
    url: '/registFrontUser',
    method: 'post',
    data: data
  })
}

// 获取图形验证码
export function captchaBusiImage() {
  return request({
    url: '/captchaBusiImage',
    headers: {
      isToken: false
    },
    method: 'get',
    timeout: 20000
  })
}

// 发送验证码
export function sendCode(data) {
  return request({
    url: '/business/loginFree/sendCode',
    method: 'post',
    data: data
  })
}

// 重置密码
export function resetPwd(data) {
  return request({
    url: '/business/loginFree/resetPwd',
    method: 'put',
    data: data
  })
}

// 获取当前人的订阅信息
export function notice() {
  return request({
    url: '/business/notice/byUserId',
    method: 'get',
    timeout: 20000
  })
}

// 订阅
export function sendNotice(data, method) {
  return request({
    url: '/business/notice',
    method: method,
    data: data
  })
}

// 当前个人订阅信息
export function selectOutTimePatentByUser(data) {
  const url = '/business/outtime/selectOutTimePatentByUser'
  const params = new URLSearchParams(data);
  return request({
    url: `${url}?${params.toString()}`,
    method: 'get'
  })
}

// 同意托管
export function agreeAgreement(data) {
  return request({
    url: '/business/agreement/agree',
    method: 'post',
    data: data
  })
}






// WEBPACK FOOTER //
// ./src/api/login.js